import {Component, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {NavigationEnd, Router} from '@angular/router';
import {filter} from 'rxjs';

@Component({
  selector: 'pc-bambuser-playlist',
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  template: `
    @for (url of [pageUrl]; track url) {
    <section aria-label="Bambuser video playlist">
      <!-- Keep the ID used by the original Bam Hub placements. -->
      <bam-playlist
        org-id="3jASAwvLHixXz2Ho7QfC"
        component-id="playlist-auto-id-0"
      ></bam-playlist>
    </section>
    }
  `,
  styles: `
    :host {
      display: block;
      width: 100%;
    }

    :host(:has(bam-playlist[data-status='empty'])) {
      display: none;
    }
  `,
})
export class BambuserPlaylistComponent {
  public pageUrl: string;

  constructor(router: Router) {
    this.pageUrl = router.url;
    // Recreate the web component when Angular reuses the page on navigation,
    // so Bambuser resolves the playlist for the new URL.
    router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        takeUntilDestroyed()
      )
      .subscribe((event: NavigationEnd) => {
        this.pageUrl = event.urlAfterRedirects;
      });

    // Only pages containing this component load the EU embed, once per document.
    const src = 'https://lcx-embed-eu.bambuser.com/default/embed.js';
    if (!document.querySelector(`script[src="${src}"]`)) {
      const script = document.createElement('script');
      script.async = true;
      script.src = src;
      script.referrerPolicy = 'no-referrer';
      document.head.appendChild(script);
    }
  }
}
